import PropTypes from 'prop-types';
import { cn } from '../../../utils';

const HelperText = ({ children, className, ...props }) => (
  <div
    className={cn(
      'flex-[1_1_auto] min-h-[12px]',
      'text-[12px] leading-[12px]',
      'text-error',
      'my-[2px] ml-[10px]',
      className
    )}
    {...props}
  >
    {children}
  </div>
);

HelperText.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export { HelperText };
